import React from 'react';
import ReactDOM from 'react-dom';
import NoResultsPage from '@src/components/no-results-page/no-results-page.jsx';
import ElementService from '@src/js/services/element-service.js';
import SearchApiService from '@src/js/services/search-api-service.js';
import { SearchApiResultsConstants as SearchResultsConstants } from '@src/js/constants.js';
import SearchResultsPageContentType from '@js/content-types/search-results-page-content-type.es6.js';

export default class NoResultsContainer {
  constructor() {
    this.elementService = new ElementService();
    this.searchApiService = new SearchApiService();

    const searchResultsPage = new SearchResultsPageContentType();
    this.noResultsDumpedText = searchResultsPage.noResultsText.item.$(0).text();
    this.tryOurToolsStartText = searchResultsPage.tryOurToolsStartingText.item.$(0).text();
    this.tryOurToolsBoldText = searchResultsPage.tryOurToolsBoldText.item.$(0).text();
    this.tryOurToolsEndText = searchResultsPage.tryOurToolsEndingText.item.$(0).text();
    this.findLabel = searchResultsPage.findLabel.item.$(0).text();
    this.servicesConditionsLabel = searchResultsPage.servicesAndConditionsLabel.item.$(0).text();
    this.viewLabel = searchResultsPage.viewLabel.item.$(0).text();
    this.providersLabel = searchResultsPage.providersResultsLabel.item.$(0).text();
    this.locationsLabel = searchResultsPage.locationsResultsLabel.item.$(0).text();
    this.servicesConditionsLink = searchResultsPage.viewAllServicesAndConditionsLink.anchor.$(0).attr('href');
    this.viewAllProvidersLink = searchResultsPage.viewAllProvidersLink.anchor.$(0).attr('href');
    this.viewAllLocationsLink = searchResultsPage.viewAllLocationsLink.anchor.$(0).attr('href');

    this.searchResultsPageWrapper = document.querySelector('.search-results-page--wrapper');
    this.noResultsContainer = this.searchResultsPageWrapper.querySelector('.no-results--container');
    this.updateContainer();
  }

  buildFindProvidersLabel() {
    return `${this.findLabel} ${this.providersLabel}`;
  }

  buildFindLocationsLabel() {
    return `${this.findLabel} ${this.locationsLabel}`;
  }

  buildServicesConditionsLabel() {
    return `${this.findLabel} ${this.servicesConditionsLabel}`;
  }

  async buildProvidersLinkText() {
    const numOfResults = (await this.searchApiService.searchProviders({ pageNum: 0 })).pager[SearchResultsConstants.TOTAL_ITEMS];
    const maxNumOfConditionsToShow = 1000;
    if (numOfResults > maxNumOfConditionsToShow) {
      return `${this.viewLabel} ${maxNumOfConditionsToShow}+ ${this.providersLabel.toLowerCase()}`;
    }
    return `${this.viewLabel} ${numOfResults} ${this.providersLabel.toLowerCase()}`;
  }

  async buildLocationsLinkText() {
    const numOfResults = (await this.searchApiService.searchLuminisLocations('', 0)).pager[SearchResultsConstants.TOTAL_ITEMS];
    const maxNumOfConditionsToShow = 50;
    if (numOfResults > maxNumOfConditionsToShow) {
      return `${this.viewLabel} ${maxNumOfConditionsToShow}+ ${this.locationsLabel.toLowerCase()}`;
    }
    return `${this.viewLabel} ${numOfResults} ${this.locationsLabel.toLowerCase()}`;
  }

  async buildServicesConditionsLinkText() {
    const numOfResults = (await this.searchApiService.searchConditionServiceTreatmentPages('', 0)).pager[SearchResultsConstants.TOTAL_ITEMS];
    const maxNumOfConditionsToShow = 200;
    if (numOfResults > maxNumOfConditionsToShow) {
      return `${this.viewLabel} ${maxNumOfConditionsToShow}+ ${this.servicesConditionsLabel.toLowerCase()}`;
    }
    return `${this.viewLabel} ${numOfResults} ${this.servicesConditionsLabel.toLowerCase()}`;
  }

  buildNoResultsText(searchedText) {
    return `${this.noResultsDumpedText} "${searchedText}"`;
  }

  buildTryOurToolsText() {
    return `<p class="try-our-tools-text">${this.tryOurToolsStartText} <strong>${this.tryOurToolsBoldText}</strong> ${this.tryOurToolsEndText}</p>`;
  }

  toggleContainerDisplay(show) {
    this.elementService.toggleVisibleStateOfElement(this.noResultsContainer, show);
  }

  async updateContainer(searchedText) {

    ReactDOM.render(
      <>
        <NoResultsPage
          key={'no-results-page'}
          noResultsText={this.buildNoResultsText(searchedText)}
          tryOurToolsHtml={this.buildTryOurToolsText()}
          findProvidersLabel={this.buildFindProvidersLabel()}
          findLocationsLabel={this.buildFindLocationsLabel()}
          findServicesConditionsLabel={this.buildServicesConditionsLabel()}
          providersLink={this.viewAllProvidersLink}
          providersLinktext={await this.buildProvidersLinkText()}
          locationsLink={this.viewAllLocationsLink}
          locationsLinktext={await this.buildLocationsLinkText()}
          servicesConditionsLink={this.servicesConditionsLink}
          servicesConditionsLinktext={await this.buildServicesConditionsLinkText()}
        />
      </>,
      this.noResultsContainer
    );
  }
}
